import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../api";

function VerifyEmail() {
  const [status, setStatus] = useState("loading"); // loading, success, error
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const verifyEmail = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const token = urlParams.get("token");
      const companyId = urlParams.get("companyId");

      if (!token || !companyId) {
        setStatus("error");
        setMessage("Invalid verification link. Missing token or company ID.");
        return;
      }

      try {
        const response = await axios.post(
          BASE_URL+'company/verifyEmail',
          { token, companyId }
        );
        console.log('console test data', response.data)
        if (response.data.code == 1) {
          setStatus("success");
          setMessage("Your email has been successfully verified!");
        } else {
          setStatus("error");
          setMessage(response.data.message || "Failed to verify email. The link may be expired or invalid.");
        }
      } catch (error) {
        console.error("Error verifying email:", error);
        setStatus("error");
        setMessage("An error occurred while verifying your email. Please try again or contact support.");
      }
    };

    verifyEmail();
  }, [navigate]);

  return (
    <div
      className="company-form-container mx-auto mt-8 md:mt-16 px-4 md:px-8 py-8 md:py-10 shadow-xl rounded-2xl border border-gray-200"
      style={{
        maxWidth: "600px",
        margin: "2rem auto",
        padding: "1.5rem 1rem 1.5rem 1rem",
        background: "#e8f3f9",
        boxShadow: "0 0 5px rgba(0, 0, 0, 0.1)"
      }}
    >
      <div className="text-center">
        {status === "success" ? (
          <img
            src="/assets/img/order-summary.png"
            alt="Email Verification"
            style={{ width: '120px', height: '68px', maxWidth: '100%' }}
            className="mx-auto mb-4"
          />
        ) : status === "loading" ? (
          <div className="d-none mx-auto mb-4" style={{ width: '50px', height: '50px' }}>
            <svg
              viewBox="0 0 50 50"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{ width: '100%', height: '100%', animation: 'spin 1s linear infinite' }}
            >
              <defs>
                <style>{`
                  @keyframes spin {
                    from { transform: rotate(0deg); }
                    to { transform: rotate(360deg); }
                  }
                `}</style>
              </defs>
              <circle
                cx="25"
                cy="25"
                r="20"
                stroke="#007bff"
                strokeWidth="4"
                strokeLinecap="round"
                fill="none"
              />
            </svg>
          </div>
        ) : (
          <div className="mx-auto mb-4" style={{ width: '50px', height: '50px' }}>
            <svg
              viewBox="0 0 80 80"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{ width: '100%', height: '100%' }}
            >
              <circle cx="40" cy="40" r="40" fill="#EF4444"/>
              <path
                d="M25 25L55 55"
                stroke="white"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <path
                d="M55 25L25 55"
                stroke="white"
                strokeWidth="6"
                strokeLinecap="round"
              />
            </svg>
          </div>
        )}
        <h2 className="text-xl md:text-2xl font-semibold text-black mb-3">
          {status === "loading" ? "Verifying Email..." : status === "success" ? "" : "Verification Failed"}
        </h2>

        {status !== "loading" && (
          <p className={`text-gray-600 text-sm md:text-base mb-4 ${
            status === "success" ? "text-green-600" : "text-red-600"
          }`}>
            {message}
          </p>
        )}

        {status == "success" && (
          <>
        <h2 className="text-xl md:text-2xl font-semibold text-black mb-3">
          Thank You!
        </h2>
        <p className="text-gray-600 text-sm md:text-base mb-4">
         Your registration has been received.
        </p>

      <div className="text-gray-600 space-y-3 leading-relaxed text-sm md:text-base text-left">
          <ul className="list-disc pl-5 space-y-2">
            <li>
              Our team will review your application
              within the next <strong>2–3 business days</strong>.
            </li>
            <li>
              Upon approval, you'll receive an
              email with login credentials to access your admin panel.
            </li>
          </ul>
      </div>
      </>
        )}
      </div>



      
        
      </div>    
  );
}

export default VerifyEmail;
